import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Country } from "../interfaces/country.interface";
import { AuthService } from "src/app/auth/services/auth.service";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CountriesService {
  private readonly _serviceUrl = environment.meetApiHost + "configurations";

  appConfigSubj = new BehaviorSubject<any>(undefined);

  constructor(
    private _http: HttpClient,
    private _auth: AuthService
  ) {}

  getConfigration() {
    return this._http.get<Country[]>(`${this._serviceUrl}`, this._auth.userToken());
  }

  getCountry(countryId: string) {
    return this._http.get<Country>(`${this._serviceUrl}/${countryId}`);
  }

  get appConfig$(): Observable<any> {
    return this.appConfigSubj.asObservable();
  }
}
